import ImpactCard from "./ImpactCard";
import { AiFillSafetyCertificate } from "react-icons/ai";
import { RiTempColdLine } from "react-icons/ri";
import { PiWarehouseFill } from "react-icons/pi";
import { FaTruck } from "react-icons/fa";

function ImpactCards() {
  const cards = [
    {
      icon: <PiWarehouseFill />,
      title: "Modern Warehousing Infrastructure",
    },
    {
      icon: <RiTempColdLine />,
      title: "Cold Storage Facilities",
    },
    {
      icon: <FaTruck />,
      title: "Integrated Logistics Support",
    },
    {
      icon: <AiFillSafetyCertificate />,
      title: "Safe & Secure Storage",
    },
  ];

  return (
    <div className="row g-4">
      {cards.map((card, idx) => (
        <div key={idx} className="col-sm-6">
          <ImpactCard {...card} />
        </div>
      ))}
    </div>
  );
}

export default ImpactCards;
